import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { ComponentConfig } from "../../services/types/ComponentTypes";

export interface ProfileEditDrawerState {
  isOpen: boolean;
  title: string;
  saveActionId: string;
  editDrawerId: string;
  fields: ComponentConfig[];
}

const initialState: ProfileEditDrawerState = {
  isOpen: false,
  title: "",
  saveActionId: "",
  editDrawerId: "",
  fields: [],
};

const profileEditDrawerSlice = createSlice({
  name: "profileEditDrawer",
  initialState,
  reducers: {
    openProfileEditDrawer(
      state,
      action: PayloadAction<{
        title: string;
        saveActionId: string;
        editDrawerId: string;
        fields: ComponentConfig[];
      }>
    ) {
      state.isOpen = true;
      state.title = action.payload.title;
      state.saveActionId = action.payload.saveActionId;
      state.editDrawerId = action.payload.editDrawerId;
      state.fields = action.payload.fields;
    },
    closeProfileEditDrawer(state) {
      state.isOpen = false;
      state.title = "";
      state.saveActionId = "";
      state.editDrawerId = "";
      state.fields = [];
    },
  },
});

export const { openProfileEditDrawer, closeProfileEditDrawer } =
  profileEditDrawerSlice.actions;

export default profileEditDrawerSlice.reducer;
